// Helper
// Check if the storage option is available for the user
function hasStorage(){
  try {
    sessionStorage.setItem('foo', 'bar');
    sessionStorage.removeItem('foo');
    return true;
  } catch (exception) {
    return false;
  }
}

// Delete local data for testing
function setSessionData(key, value){
  var k = (key) ? key : "empireData";
  var v = (value) ? value : "false";

  if(hasStorage()) {
    sessionStorage.setItem(k, v);
  }
  else{
    document.cookie = key+"="+ v;
  }
}

// Delete session via session storage or cookie
function deleteSessionData(key){
  var k = (key) ? key : "empireData";
  if(hasStorage()){
    sessionStorage.removeItem(k);
  }
  else{
    var expiryDate = new Date();
    expiryDate.setTime(expiryDate.getTime() - 86400 * 1000);
    cookieString += ';max-age=0';
    cookieString += ';expires=' + expiryDate.toUTCString();

    document.cookie = k + ';max-age=0; expires=' + expiryDate.toUTCString();
  }
}

// Get session data via session storage or cookie
function getSessionData(key){
  var k = (key) ? key : "empireData";
  var value = null;

  if(hasStorage()){
    value = sessionStorage.getItem(k);
  }
  else{
    var cookie = getCookie(k);
    if(cookie){
      value = cookie.substring(cookie.indexOf('=') + 1);
    }
   
  }
  return value;
}

// Get value of specific cookie
function getCookie(key){
  if (document.cookie.length > 0) {
    var cStart = document.cookie.indexOf(key + "=");
    if (cStart != -1) {
      cStart = cStart + key.length + 1;

      var cEnd = document.cookie.indexOf(";", cStart);
      if (cEnd == -1) {
        cEnd = document.cookie.length;
      }
      return unescape(document.cookie.substring(cStart, cEnd));
    }
  }
  return null;
}